<template>
  <v-card class="card" color="primary">
    <v-card-text class="d-flex justify-space-between">
      <v-container>
        <v-row v-if="perfil === PERFILES['Administrador IPH+'] || perfil === PERFILES['Policia']">
          <v-col align="right">
            <TextButton @click="openAgregarEstudio"> AGREGAR ESTUDIO </TextButton>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <estudios-table :estudios="estudios" :loading="loading" @edit="editarEstudio" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import { PERFILES } from '@/perfiles.js'
import TextButton from '../../../base/TextButton.vue'
import EstudiosTable from '../../estudios/EstudiosTable.vue'

export default {
  components: {
    TextButton,
    EstudiosTable,
  },
  data() {
    return {
      PERFILES,
      DIALOG_TYPES,
      loading: false,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
    ...mapGetters('estudio', {
      estudiosAll: 'getEstudios',
    }),
    idPersonal() {
      return this.personal?.idPersonal
    },
    estudios() {
      return this.estudiosAll.filter((e) => e.fk_idPersonal == this.idPersonal)
    },
  },
  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('estudio', ['SET_SELECTED_ESTUDIO']),
    ...mapActions('estudio', ['fetchEstudiosByPersonal']),

    openAgregarEstudio() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.AGREGAR_ESTUDIO,
        props: {
          id: this.idPersonal,
        },
      })
    },

    editarEstudio(estudio) {
      this.SET_SELECTED_ESTUDIO(estudio)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_ESTUDIO)
    },
  },
  async mounted() {
    if (this.idPersonal) {
      this.loading = true
      await this.fetchEstudiosByPersonal(this.idPersonal)
      this.loading = false
    }
  },
}
</script>
